var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"how-it-works"},[_c('h2',{staticClass:"how-it-works__title"},[_vm._v("Come funziona")]),_c('pointer-list',{attrs:{"orientation":"horizontal","steps":_vm.steps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }